import findIndex from 'lodash.findindex'
import { getCookie } from '~/plugins/xl-cookie'

/**
 * 计算优惠额度
 * @param curBaseRMB 基础支付金额
 * @param curCouponItem 当前选择的优惠劵
 * */
export const getDiscounts = function(curBaseRMB, curCouponItem) {
  let discountMoney = 0
  switch (curCouponItem.gift_type) {
    case 'voucher':
    case 'thunder_voucher':
    case 'cash':
      discountMoney = curCouponItem.value
      break
    case 'discount':
      discountMoney = curBaseRMB * (1 - curCouponItem.value / 100)
      break
    case 'thunder_discount':
    case 'thunder_extra_discount':
      discountMoney = curBaseRMB * (1 - curCouponItem.value / 100)
      discountMoney =
        discountMoney > curCouponItem.threshold
          ? curCouponItem.threshold
          : discountMoney
      break
    case 'thunder_golden_beans':
      discountMoney = curCouponItem.value
      discountMoney =
        curBaseRMB - discountMoney >= 1 ? discountMoney : curBaseRMB - 1
      break
    default:
      discountMoney = curCouponItem.value
      break
  }
  discountMoney = discountMoney > 0 ? discountMoney : 0
  return discountMoney
}

/**
 * 数组扁平化
 * */
function flatArr(arr = [], depth) {
  if (depth === undefined) {
    depth = 1
  }
  while (arr.some((item) => Array.isArray(item) && depth > 0)) {
    arr = [].concat(...arr)
    depth--
  }
  return arr
}

export const state = () => ({
  serverList: [],
  roleList: [],
  curRoleIndex: -1,
  curGameIndex: -1,
  curAreaIndex: -1,
  deliverUserId: '',
  expressUserId: '',
  inputAcc: '',
  errTip: '',
  rmbList: [
    { title: '10元', val: 10 },
    { title: '100元', val: 100 },
    { title: '200元', val: 200 },
    { title: '500元', val: 500 },
    { title: '1000元', val: 1000 },
    { title: '2000元', val: 2000 },
    { title: '5000元', val: 5000 }
  ],
  rmbCur: 0,
  rmbInput: 0,
  yuan: null,
  paySuccess: false,
  qrImg: null,
  couponTabs: [
    {
      title: '全部优惠券',
      type: 'all',
      cur: true,
      list: [],
      pages: 1,
      index: 1,
      pageSize: 4,
      checked: -1
    },
    {
      title: '代金券',
      type: 'voucher',
      cur: false,
      list: [],
      pages: 1,
      index: 1,
      pageSize: 4,
      checked: -1
    },
    {
      title: '现金券',
      type: 'cash',
      cur: false,
      list: [],
      pages: 1,
      index: 1,
      pageSize: 4,
      checked: -1
    },
    {
      title: '折扣券',
      type: 'discount',
      cur: false,
      list: [],
      pages: 1,
      index: 1,
      pageSize: 4,
      checked: -1
    },
    {
      title: '迅雷盒子折扣券',
      type: 'thunder_discount',
      cur: false,
      list: [],
      pages: 1,
      index: 1,
      pageSize: 4,
      checked: -1
    },
    {
      title: '迅雷盒子代金券',
      type: 'thunder_voucher',
      cur: false,
      list: [],
      pages: 1,
      index: 1,
      pageSize: 4,
      checked: -1
    },
    {
      title: '迅雷盒子活动折扣券',
      type: 'thunder_extra_discount',
      cur: false,
      list: [],
      pages: 1,
      index: 1,
      pageSize: 4,
      checked: -1
    },
    {
      title: '迅雷金豆',
      type: 'thunder_golden_beans',
      cur: false,
      list: [],
      pages: 1,
      index: 1,
      pageSize: 4,
      checked: -1
    }
  ],
  playedGames: [],
  rebateGameOption: [], // 返利游戏配置
  isDisabledRebateAct: false, // 返利游戏配置时效是否过期
  playedArea: [],
  curCouponItem: { value: 0 },
  payAd: {},
  defaultMaxCoupon: [], // 默认优惠力度最大的两张劵
  defaultDisabledCoupon: [] // 默认不可用的两张劵
})

export const getters = {
  curCoupon(state) {
    return state.couponTabs.filter((e) => e.cur)[0]
  },
  // curCouponItem(_, getters) {
  //   return getters.conditionList.filter((e) => e.checked)[0] || { value: 0 }
  // },

  // 激活tab所属的劵
  conditionList(state, getters) {
    const list = getters.curCoupon.list
    const availableForRMB = [[], []]
    const availableForGame = []
    const unavailable = []
    const { game_id } = getters.curGame
    const { server_id } = getters.curArea
    list.forEach((item) => {
      if (item.state === 'frozen' && !item.checked) {
        unavailable.push({ ...item, status_txt: '冻结' })
      } else if (item.bind_game_id === game_id || !item.bind_game_id) {
        const rmbFlag = {
          voucher: item.condition <= getters.rmb,
          thunder_voucher: item.condition <= getters.rmb,
          cash: item.condition <= getters.rmb,
          discount:
            item.condition <= getters.rmb && item.condition_end >= getters.rmb,
          thunder_discount:
            item.condition <= getters.rmb && item.condition_end >= getters.rmb,
          thunder_extra_discount:
            item.condition <= getters.rmb && item.condition_end >= getters.rmb,
          thunder_golden_beans:
            item.state === 'valid' && item.expire_time_countdown > 0
        }[item.gift_type]
        let serverFlag =
          item.bind_server_id === server_id || !item.bind_server_id

        if (!item.bind_game_id && item.astrict_games) {
          // 如果没有绑定单游戏id, 但又有绑定多游戏则不校验绑定单游戏区服
          serverFlag = true
          const astrict_games = JSON.parse(item.astrict_games)
          // 选择游戏不在绑定多游戏列表中
          if (!astrict_games.includes(game_id)) {
            let status_txt = '可使用的游戏范围：'
            for (const astrictItemId of astrict_games) {
              for (const serverListItem of state.serverList) {
                if (serverListItem.game_id === astrictItemId) {
                  if (serverListItem.title) {
                    status_txt += serverListItem.title + '，'
                  }
                  break
                }
              }
            }
            unavailable.push({
              ...item,
              checked: false,
              status_txt: status_txt.slice(0, -1)
            })
            return
          }
        }

        if (rmbFlag && serverFlag) {
          availableForRMB[item.state === 'frozen' ? 1 : 0].push({
            ...item,
            status_txt: item.state === 'frozen' ? '冻结' : '可用'
          })
        } else {
          availableForGame.push({
            ...item,
            checked: false,
            status_txt: rmbFlag ? '该游戏区服不可用' : '该充值金额不可用'
          })
        }
      } else {
        unavailable.push({
          ...item,
          checked: false,
          status_txt: '该游戏不可用'
        })
      }
    })
    const availableForRMB_0 = availableForRMB[0].sort(
      (a, b) => b.discountsVal - a.discountsVal
    )

    // 处理迅雷盒子活动折扣券
    const thunderExtraDiscountIndex = availableForRMB_0.findIndex(
      (item) => item.gift_type === 'thunder_extra_discount'
    )
    if (thunderExtraDiscountIndex >= 0) {
      const thunderExtraDiscountItem = availableForRMB_0.splice(
        thunderExtraDiscountIndex,
        1
      )[0]
      availableForRMB_0.unshift(thunderExtraDiscountItem)
    }

    // 将金豆优惠券排在最前面（优先级高于迅雷盒子活动折扣券）
    const thunderGoldenBeansIndex = availableForRMB_0.findIndex(
      (item) => item.gift_type === 'thunder_golden_beans'
    )
    if (thunderGoldenBeansIndex >= 0) {
      const thunderGoldenBeansItem = availableForRMB_0.splice(
        thunderGoldenBeansIndex,
        1
      )[0]
      availableForRMB_0.unshift(thunderGoldenBeansItem)
    }
    return [
      ...availableForRMB_0,
      ...availableForRMB[1].sort((a, b) => b.discountsVal - a.discountsVal),
      ...availableForGame.sort((a, b) => b.discountsVal - a.discountsVal),
      ...unavailable.sort((a, b) => b.discountsVal - a.discountsVal)
    ]
  },
  // 全部的劵
  conditionList_All(state, getters) {
    const list = state.couponTabs.slice(0, 1).flatMap((item) => item.list)
    const availableForRMB = []
    const availableForGame = []
    const unavailable = []
    const { game_id } = getters.curGame
    const { server_id } = getters.curArea
    list.forEach((item) => {
      if (item.state === 'frozen' && !item.checked) {
        unavailable.push({ ...item, status_txt: '冻结' })
      } else if (item.bind_game_id === game_id || !item.bind_game_id) {
        // const rmbFlag = item.condition <= getters.rmb
        const rmbFlag = {
          voucher: item.condition <= getters.rmb,
          thunder_voucher: item.condition <= getters.rmb,
          cash: item.condition <= getters.rmb,
          discount:
            item.condition <= getters.rmb && item.condition_end >= getters.rmb,
          thunder_discount:
            item.condition <= getters.rmb && item.condition_end >= getters.rmb,
          thunder_extra_discount:
            item.condition <= getters.rmb && item.condition_end >= getters.rmb,
          thunder_golden_beans:
            item.state === 'valid' && item.expire_time_countdown > 0
        }[item.gift_type]
        let serverFlag =
          item.bind_server_id === server_id || !item.bind_server_id

        if (!item.bind_game_id && item.astrict_games) {
          // 如果没有绑定单游戏id, 但又有绑定多游戏则不校验绑定单游戏区服
          serverFlag = true
          const astrict_games = JSON.parse(item.astrict_games)
          // 选择游戏不在绑定多游戏列表中
          if (!astrict_games.includes(game_id)) {
            let status_txt = '可使用的游戏范围：'
            for (const astrictItemId of astrict_games) {
              for (const serverListItem of state.serverList) {
                if (serverListItem.game_id === astrictItemId) {
                  if (serverListItem.title) {
                    status_txt += serverListItem.title + '，'
                  }
                  break
                }
              }
            }
            unavailable.push({
              ...item,
              checked: false,
              status_txt: status_txt.slice(0, -1)
            })
            return
          }
        }

        if (rmbFlag && serverFlag) {
          availableForRMB.push({
            ...item,
            status_txt: item.state === 'frozen' ? '冻结' : '可用'
          })
        } else {
          availableForGame.push({
            ...item,
            checked: false,
            status_txt: rmbFlag ? '该游戏区服不可用' : '该充值金额不可用'
          })
        }
      } else {
        unavailable.push({
          ...item,
          checked: false,
          status_txt: '该游戏不可用'
        })
      }
    })
    return [
      ...availableForRMB.sort((a, b) => b.value - a.value),
      ...availableForGame.sort((a, b) => b.value - a.value),
      ...unavailable.sort((a, b) => b.value - a.value)
    ]
  },
  curCouponList(state, getters) {
    const { pageSize, index } = getters.curCoupon
    const list = getters.conditionList
    return list.slice((index - 1) * pageSize, index * pageSize)
  },
  areaList(state, getters) {
    const server_list = getters.curGame.server_list || []
    const playedArea = state.playedArea || []
    const contactList = [...server_list, ...playedArea]
    const obj = {}
    const filterList = contactList.reduce((item, next) => {
      if (!obj[next.server_id]) {
        obj[next.server_id] = true
        item.push(next)
      }
      return item
    }, [])
    const sortList = filterList.sort((a, b) => {
      const key = 'server_num'
      const x = a[key]
      const y = b[key]
      return y - x
    })
    return sortList
  },
  curRole(state) {
    return state.roleList[state.curRoleIndex] || {}
  },
  curGame(state) {
    return state.serverList[state.curGameIndex] || {}
  },
  curArea(state, getters) {
    return getters.areaList[state.curAreaIndex] || {}
  },
  isNeedGameRole(state) {
    let isNeed = true
    const { extra_json = '' } = state.serverList[state.curGameIndex] || {}
    try {
      const { noGR } = JSON.parse(extra_json)
      // 不需要角色信息
      if (noGR === 1) {
        isNeed = false
      }
    } catch (e) {
      console.log(e)
    }
    return isNeed
  },
  rmb(state) {
    return (
      (state.rmbCur >= 0 ? state.rmbList[state.rmbCur].val : state.rmbInput) *
      100
    )
  },
  realRmb(state, getters) {
    return Math.max(
      getters.rmb - getDiscounts(getters.rmb, state.curCouponItem),
      0
    )
  },
  isPay0(_, getters) {
    return getters.curCoupon.type === 'cash' && getters.realRmb === 0
  },
  // 是否显示返利金额
  isShowRebateMoney(state, getters) {
    if (state.rebateGameOption.length === 0) {
      return false
    }
    if (Object.keys(getters.curGame).length === 0) {
      return false
    }
    if (getters.rmb !== getters.realRmb) {
      return false
    }
    if (getters.rebateMoneyCount === 0) {
      return false
    }
    let list =
      state.rebateGameOption.map((item) =>
        item.activityNewGames.map((item) => item.gameID)
      ) || []
    list = flatArr(list, Infinity)
    return list.includes(getters.curGame.game_id)
  },
  // 选中的返利活动配置
  getActiveRebateMoney(state, getters) {
    if (state.rebateGameOption.length === 0) {
      return false
    }
    if (Object.keys(getters.curGame).length === 0) {
      return false
    }

    return state.rebateGameOption.find((item) =>
      item.activityNewGames
        .map((val) => val.gameID)
        .includes(getters.curGame.game_id)
    )
  },
  // 返利金额
  rebateMoneyCount(state, getters) {
    if (state.rebateGameOption.length === 0) {
      return 0
    }

    const item = getters.getActiveRebateMoney
      ? getters.getActiveRebateMoney.activityNewPackages.find(
          (item) =>
            item.min <= getters.rmb / 100 && getters.rmb / 100 <= item.max
        )
      : false

    if (!item) {
      return 0
    }

    const money = [
      0,
      // item.returnWay:1 比例
      parseInt(((item.num / 100) * getters.rmb) / 100),
      // item.returnWay:2 固定
      item.num
    ][item.returnWay]

    return money
  },
  ext2(state, getters) {
    const { curGame, curArea, curRole } = getters
    const gift_type = state.curCouponItem.gift_type || ''
    const isThunder = gift_type.includes('thunder_')
    // 默认为default；迅雷盒子：thunder
    const broker = isThunder ? 'thunder' : 'default'
    // 对应券码code
    const xl_voucher_code = isThunder ? state.curCouponItem.code : ''
    // 返利活动 => 匹配成功 && 符合显示条件 && 未过期
    const rebateGame =
      getters.getActiveRebateMoney &&
      getters.isShowRebateMoney &&
      !state.isDisabledRebateAct
        ? {
            act_id:
              getters.getActiveRebateMoney?.activityNewGames[0].activityNewID,
            act_no: getters.getActiveRebateMoney?.code
          }
        : {}
    return Object.assign(
      {},
      {
        broker,
        xl_voucher_code,
        deliver_userid: state.deliverUserId,
        role_id: curRole.role_id || '',
        role_name: curRole.role_name || '',
        game_id: curGame.game_id + '',
        server_id: curArea.server_id,
        user_id: getCookie('userid'),
        coupon_id: state.curCouponItem.coupon_id || '',
        coupon_code: state.curCouponItem.code || '' // 对应券码code
      },
      rebateGame
    )
  },
  isSelfAccount(state, getters, rootState) {
    return state.inputAcc === rootState.userInfo.account
  }
}

export const mutations = {
  setIsDisabledRebateAct(state, bool) {
    state.isDisabledRebateAct = bool
  },
  setQrImg(state, img) {
    state.qrImg = img
  },
  setYuan(state, yuan) {
    state.yuan = yuan
  },
  setServerList(state, arr = []) {
    state.serverList = arr
  },
  setRoleList(state, arr = []) {
    state.roleList = arr
  },
  setDeliverUserId(state, id) {
    state.deliverUserId = id
  },
  setExpressUserId(state, id) {
    state.expressUserId = id
  },
  setErrTip(state, tip) {
    state.errTip = tip
  },
  setInputAcc(state, val) {
    state.inputAcc = val
  },
  changeGameIndex(state, index) {
    state.curGameIndex = index
    state.curAreaIndex = -1
    state.curRoleIndex = -1
    state.roleList = []
  },
  changeAreaIndex(state, index) {
    state.curAreaIndex = index
  },
  changeRoleIndex(state, index) {
    state.curRoleIndex = index
  },
  changeRmbCur(state, index) {
    state.rmbCur = index
  },
  rmbInput(state, val) {
    state.rmbCur = -1
    state.rmbInput = +val
  },
  setPayStatus(state, flag) {
    state.paySuccess = flag
  },
  setPayAd(state, params = {}) {
    state.payAd = params
  },

  // 设置优惠劵
  setCoupons(state, [type, coupons, coupon_code]) {
    const index = state.couponTabs.findIndex((e) => e.type === type)
    if (index < 0) return
    coupon_code = coupon_code || state.curCouponItem.code
    state.couponTabs[index].list = commitList(coupons)
    state.couponTabs[index].pages = Math.ceil(
      coupons.length / state.couponTabs[index].pageSize
    )

    // 设置全局优惠劵list
    let allList = state.couponTabs
      .slice(1)
      .flatMap((item) => JSON.parse(JSON.stringify(item.list)))
    allList = commitList(allList)

    for (const item of allList) {
      item.discountsVal = getDiscounts(getCurRmb(), item)
    }

    allList.sort((pre, next) => next.discountsVal - pre.discountsVal)

    // 处理迅雷盒子活动折扣券
    const thunderExtraDiscountIndex = allList.findIndex(
      (item) => item.gift_type === 'thunder_extra_discount'
    )
    if (thunderExtraDiscountIndex >= 0) {
      const thunderExtraDiscountItem = allList.splice(
        thunderExtraDiscountIndex,
        1
      )[0]
      allList.unshift(thunderExtraDiscountItem)
    }

    // 将金豆优惠券排在最前面（优先级高于迅雷盒子活动折扣券）
    const thunderGoldenBeansIndex = allList.findIndex(
      (item) => item.gift_type === 'thunder_golden_beans'
    )
    if (thunderGoldenBeansIndex >= 0) {
      const thunderGoldenBeansItem = allList.splice(
        thunderGoldenBeansIndex,
        1
      )[0]
      allList.unshift(thunderGoldenBeansItem)
    }
    state.couponTabs[0].list = allList
    state.couponTabs[0].pages = Math.ceil(
      allList.length / state.couponTabs[0].pageSize
    )

    function commitList(coupons) {
      return coupons.map((e, i) => {
        if (e.bind_game_id) {
          const gameItem =
            state.serverList.filter((i) => i.game_id === e.bind_game_id)[0] ||
            {}
          e.game_title = gameItem.title || '--'
          if (e.bind_server_id) {
            e.server_name =
              (
                (gameItem.server_list || []).filter(
                  (i) => i.server_id === e.bind_server_id
                )[0] || {}
              ).title || '--'
          } else {
            e.server_name = '所有区服'
          }
        } else if (e.astrict_games) {
          e.game_title = '部分游戏'
          e.server_name = '所有区服'
        } else {
          e.game_title = '所有游戏'
          e.server_name = '所有区服'
        }
        e.checked = e.code === coupon_code
        e.index = i
        e.status_txt = e.state === 'valid' ? '可用' : '不可用'
        // 这里好怪，如果不用析构，插入的check,index这些字段没有变成响应式
        return { ...e }
      })
    }

    function getCurRmb() {
      return (
        (state.rmbCur >= 0 ? state.rmbList[state.rmbCur].val : state.rmbInput) *
        100
      )
    }
  },
  setCouponIndex(state, index) {
    const item = state.couponTabs.filter((e) => e.cur)[0]
    item.index = index
  },
  changeCurCoupon(state, type) {
    // 充值页面没有显示 thunder_extra_discount 类型
    if (type === 'thunder_extra_discount') {
      type = 'all'
    }
    state.couponTabs.forEach((e) => (e.cur = e.type === type))
  },
  // 选中优惠劵item
  choiceCoupon(state, [index, item]) {
    if (index >= 0 && item === undefined) {
      const couponTab = state.couponTabs.filter((e) => e.cur)[0]
      couponTab.list.forEach((e) => (e.checked = false))
      state.curCouponItem = { ...couponTab.list[index] }
    } else if (
      index === -2 &&
      Object.prototype.toString.call(item) === '[object Object]'
    ) {
      state.curCouponItem = item
    } else {
      // 选择默认优惠券
      const beanCoupon = state.defaultMaxCoupon.find(
        (_item) => _item.gift_type === 'thunder_golden_beans'
      )
      if (beanCoupon) {
        state.curCouponItem = beanCoupon
      } else {
        state.curCouponItem = { value: 0 }
      }
    }
  },
  setPlayedGames(state, list) {
    state.playedGames = list
  },
  setRebateGameOption(state, data) {
    state.rebateGameOption = data
  },
  setPlayedArea(state, list) {
    state.playedArea = list
  },
  // 匹配可用额度最大的优惠劵
  matchMaxCoupon(state, [curBaseRMB, conditionList_All]) {
    const usable = conditionList_All.filter(
      (item) => item.status_txt === '可用'
    )
    const disabled = conditionList_All.filter(
      (item) => item.status_txt !== '可用'
    )

    for (const item of usable) {
      // 设置优惠的额度
      item.discountsVal = getDiscounts(curBaseRMB, item)
    }
    for (const item of disabled) {
      // 设置优惠的额度
      item.discountsVal = getDiscounts(curBaseRMB, item)
    }

    // 降序
    usable.sort((pre, next) => next.discountsVal - pre.discountsVal)
    disabled.sort((pre, next) => next.discountsVal - pre.discountsVal)

    // 处理迅雷盒子活动折扣券
    const thunderExtraDiscountIndex = usable.findIndex(
      (item) => item.gift_type === 'thunder_extra_discount'
    )
    if (thunderExtraDiscountIndex >= 0) {
      const thunderExtraDiscountItem = usable.splice(
        thunderExtraDiscountIndex,
        1
      )[0]
      usable.unshift(thunderExtraDiscountItem)
    }

    // 将金豆优惠券排在最前面（优先级高于迅雷盒子活动折扣券）
    const thunderGoldenBeansIndex = usable.findIndex(
      (item) => item.gift_type === 'thunder_golden_beans'
    )
    if (thunderGoldenBeansIndex >= 0) {
      const thunderGoldenBeansItem = usable.splice(
        thunderGoldenBeansIndex,
        1
      )[0]
      usable.unshift(thunderGoldenBeansItem)
    }
    state.defaultMaxCoupon = JSON.parse(JSON.stringify(usable)).splice(0, 4)
    state.defaultDisabledCoupon = JSON.parse(JSON.stringify(disabled)).splice(
      0,
      4
    )
  }
}

export const actions = {
  getServerList({ commit, dispatch }, isGameLatest) {
    return this.$request(
      isGameLatest ? 'gameRecently' : 'cateServerList',
      isGameLatest ? {} : { body: { code_sort: 'sort' } }
    ).then((data = []) => {
      commit(
        'setServerList',
        data
          .filter((e) =>
            isGameLatest ? true : this.$util.getPayStatus(e.pay_status)
          )
          .map((e, i) => ({ ...e, index: i }))
      )
      return dispatch('initFromQuery')
    })
  },
  getRole({ commit, state, getters, rootState }, roleId) {
    // 不需要角色信息
    if (!getters.isNeedGameRole) {
      commit('setRoleList', [])
      commit('changeRoleIndex', -1)
      commit('setDeliverUserId', '')
      return
    }
    if (state.curGameIndex < 0 || state.curAreaIndex < 0) return
    commit('setErrTip', '')
    return this.$request('gameRole', {
      body: {
        account:
          rootState.userInfo.account === state.inputAcc ? '' : state.inputAcc,
        game_id: getters.curGame.game_id,
        server_id: getters.curArea.server_id,
        client_type: this.$util.getClientType()
      }
    })
      .then((data = {}) => {
        if (!data.role_list || !data.role_list.length) {
          return Promise.reject(new Error('未查询到角色信息'))
        }
        commit('setRoleList', data.role_list)
        commit(
          'changeRoleIndex',
          roleId
            ? data.role_list.findIndex((item) => item.role_id === roleId)
            : data.role_list.length === 1
            ? 0
            : -1
        )
        commit('setDeliverUserId', data.user_id)
      })
      .catch((err) => {
        commit('setRoleList', [])
        commit('changeRoleIndex', -1)
        commit('setDeliverUserId', '')
        commit('setErrTip', err.message)
      })
  },
  async initFromQuery({ state, commit, getters, rootState, dispatch }) {
    const {
      game_id,
      server_id,
      server_num,
      sid = '',
      game_role_id = ''
    } = rootState.route.query
    if (game_id) {
      const gameIndex = findIndex(
        state.serverList,
        (e) => e.game_id === +game_id
      )
      commit('changeGameIndex', gameIndex)
      await dispatch('getPlayedArea', game_id)
      if (gameIndex > -1) {
        let areaIndex = -1
        if (server_id) {
          areaIndex = findIndex(
            getters.areaList,
            (e) => e.server_id === +server_id
          )
        } else if (server_num || sid) {
          areaIndex = findIndex(
            getters.areaList,
            (e) => e.server_num === (server_num || sid)
          )
        }
        commit('changeAreaIndex', areaIndex)
      }
      return dispatch('getRole', game_role_id)
    } else {
      commit('changeGameIndex', -1)
      commit('changeAreaIndex', -1)
    }
  },
  // 获取代金劵列表
  async initCouponByQuery({ commit, state, rootState, getters, dispatch }) {
    let { coupon_code, coupon_type } = rootState.route.query
    // 如果已选优惠劵
    if (state.curCouponItem && state.curCouponItem.code) {
      coupon_code = state.curCouponItem.code
      coupon_type = state.curCouponItem.gift_type
    }
    // 获取[激活的tabItem, allTab]以外的tabList
    await Promise.all(
      state.couponTabs
        .filter(
          (item) =>
            item.type !== 'all' &&
            (coupon_type === undefined ? true : item.type !== coupon_type)
        )
        .map(async (item) => {
          // 获取tabList
          const data = await dispatch(
            'updateOtherCoupon',
            item.type
          ).catch(() => {})
          return data
        })
    )

    // 等于 undefined 表示未选中优惠劵
    if (coupon_type !== undefined) {
      // 获取激活的tabList
      return this.$request('userCouponCodes', {
        body: {
          user_id: this.$cookies.get('userid'),
          gift_type: coupon_type
        }
      }).then((data = {}) => {
        // 设置激活的tab
        commit('changeCurCoupon', coupon_type)

        // 重新渲染激活的tabItem
        commit('setCoupons', [coupon_type, data.coupon_list || [], coupon_code])
      })
    } else {
      // 设置激活的tab
      commit('changeCurCoupon', state.couponTabs[0].type)
    }
  },
  updateOtherCoupon({ commit, state, getters }, coupon_type) {
    return this.$request('userCouponCodes', {
      body: {
        user_id: this.$cookies.get('userid'),
        gift_type: coupon_type
      }
    }).then((data = {}) => {
      commit('setCoupons', [coupon_type, data.coupon_list || []])
      return data
    })
  },
  getCoupons({ getters, commit }) {
    return this.$request('userCouponCodes', {
      body: {
        user_id: this.$cookies.get('userid'),
        gift_type: getters.curCoupon.type
      }
    }).then((data = {}) => {
      commit('setCoupons', [getters.curCoupon.type, data.coupon_list || []])
    })
  },
  // 优惠券兑换码
  async getCouponByCode({ dispatch, commit, getters }, code) {
    if (!code) return
    const flag = await dispatch('autoChoiceCoupon', code)
    if (flag) return
    return this.$request('couponCode', {
      body: {
        code,
        game_id: getters.curGame.game_id,
        server_id: getters.curArea.server_id,
        user_id: this.$cookies.get('userid')
      }
    })
      .then((data) => {
        commit('changeCurCoupon', data.gift_type)
        dispatch('getCoupons').then(() => dispatch('autoChoiceCoupon', code))
      })
      .catch((err) => this.$notify(err.message))
  },
  changeCouponType({ commit, dispatch }, type) {
    commit('changeCurCoupon', type)
    // return dispatch('getCoupons')
  },
  getPlayedGame({ commit }) {
    return this.$request('gameRecently').then((data = []) => {
      commit(
        'setPlayedGames',
        data.filter((e) => this.$util.getPayStatus(e.pay_status))
      )
    })
  },
  // 返利游戏配置
  getRebateGame({ commit }) {
    return this.$request('rebateGame').then((data = []) => {
      commit('setRebateGameOption', data)
    })
  },
  async getPlayedArea({ commit }, game_id) {
    await this.$request('gameRecently', {
      body: { game_id }
    }).then((data = [{}]) => {
      commit('setPlayedArea', data[0].latest_server_list || [])
    })
  },
  // 快捷充值传过来的uid需转换成迅雷用户id
  convertToUserId({ state, commit, rootState }) {
    return new Promise((resolve) => {
      const { uid = '', game_id = '', sid = '' } = rootState.route.query
      const userid = this.$cookies.get('userid')
      if (!uid) {
        return resolve({
          status: false,
          msg: '缺少uid参数'
        })
      }
      if (!game_id) {
        return resolve({
          status: false,
          msg: '缺少game_id参数'
        })
      }
      if (!sid) {
        return resolve({
          status: false,
          msg: '缺少sid参数'
        })
      }
      if (!userid) {
        return resolve({
          status: false,
          msg: '请先登陆'
        })
      }
      // 已经换过迅雷uid就不再请求接口了
      if (state.expressUserId) {
        // 对比当前登陆的uid
        if (state.expressUserId !== userid) {
          return resolve({
            status: false,
            msg: '您要充值账号，与当前环境登录的账号不一致，请重新登录！'
          })
        }
        return resolve({
          status: true,
          msg: ''
        })
      }
      const ts = new Date().getTime()
      const params = {
        uid,
        game_id,
        ts
      }
      const key = '068A1632183077FA'
      params.sign = this.$util.genSign(params, key)
      this.$axios
        .get('//api-wan-ssl.xunlei.com/v1/user/auth/check', {
          params
        })
        .then((req) => {
          const result = req.data
          if (result.code !== 0 || !result.data) {
            return resolve({
              status: false,
              msg: result.message
            })
          }
          const resultUId = String(result.data.uid)
          commit('setExpressUserId', resultUId)
          // 对比当前登陆的uid
          if (resultUId !== userid) {
            return resolve({
              status: false,
              msg: '您要充值账号，与当前环境登录的账号不一致，请重新登录！'
            })
          }
          return resolve({
            status: true,
            msg: ''
          })
        })
    })
  },
  changeCurGame({ commit, state, dispatch }, game) {
    const cur = state.serverList.filter((e) => e.game_id === game.game_id)[0]
    commit('changeGameIndex', cur.index)
    commit('choiceCoupon', [-1])
    return dispatch('getPlayedArea', cur.game_id)
  },
  changeCurArea({ commit, dispatch, getters }, area) {
    const index = findIndex(
      getters.areaList,
      (e) => e.server_id === area.server_id
    )
    commit('setRoleList', [])
    commit('changeAreaIndex', index)
    commit('choiceCoupon', [-1])
    return dispatch('getRole')
  },
  autoChoiceCoupon({ commit, state, getters }, code) {
    let tabIndex = 0
    let index = findIndex(state.couponTabs[tabIndex].list, ['code', code])
    if (index < 0) {
      tabIndex = 1
      index = findIndex(state.couponTabs[tabIndex].list, ['code', code])
    }
    if (index >= 0) {
      commit('changeCurCoupon', state.couponTabs[index].type)
      const cIndex = findIndex(getters.conditionList, ['code', code])
      if (getters.conditionList[cIndex].status_txt === '可用') {
        commit('choiceCoupon', [index])
        commit(
          'setCouponIndex',
          Math.floor(cIndex / state.couponTabs[tabIndex].pageSize) + 1
        )
      }
      return true
    }
    return false
  },
  getPayAd({ commit, state, getters }) {
    if (state.payAd.Description) {
      const promise = new Promise((resolve) => {
        resolve()
      })
      return promise
    }
    return this.$request('payAd').then((data = {}) => {
      commit('setPayAd', data)
    })
  }
}
